import React from 'react'
import { styled } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'
import { PlayIcon, BorderedGreenButton } from 'components'
import PropTypes from 'prop-types'
import SEQUENCE_TAGS from 'constants/sequenceTags'

const Video = styled('div')(({ image }) => ({
  height: '65px',
  borderRadius: '12px',
  margin: '0 5px 2px',
  border: 'var(--grey-solid) 1px',
  backgroundImage: image ? `url(${image})` : 'none',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const Tag = styled(BorderedGreenButton)({
  height: '18px',
  fontSize: '70%',
})

const VideoContainer = styled('div')({
  marginBottom: '15px',
})

const Sequences = ({ sequences, changeSelectedSequenceId }) => {
  return (
    <>
      {sequences
        .filterById('new')
        .map(
          ({
            id,
            thumbnail_url: thumbnail,
            processed,
            error_details: errorDetails,
            tag,
          }) => {
            const tagData = SEQUENCE_TAGS.find(({ value }) => value === tag)

            return (
              <VideoContainer key={id}>
                <Video image={processed === 1 && thumbnail}>
                  {(() => {
                    if (errorDetails) {
                      return <>{errorDetails}</>
                    }
                    if (processed !== 1) {
                      return <CircularProgress color="primary" size={24} />
                    }

                    return (
                      <PlayIcon
                        color="primary"
                        onClick={() => changeSelectedSequenceId(id)}
                      />
                    )
                  })()}
                </Video>
                <Tag background={tagData.background} color={tagData.color}>
                  {tagData.title}
                </Tag>
              </VideoContainer>
            )
          }
        )}
    </>
  )
}

Sequences.defaultProps = {
  sequences: [],
}

Sequences.propTypes = {
  sequences: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      thumbnail_url: PropTypes.string,
      processed: PropTypes.number,
      error_details: PropTypes.string,
      tag: PropTypes.string,
    })
  ),
  changeSelectedSequenceId: PropTypes.func.isRequired,
}

export default Sequences
